import $ from "jquery";
import sanitizeHtml from "sanitize-html";

let map;
let cityCircle = null;
declare let google;

function initMap() {
  const $advLocationMap = $(".js-adviser-location-map");
  const { lat, lng, zoom, mapstyle, radius } = $advLocationMap.data();
  var showpin,
    showradius = false;

  switch (mapstyle) {
    case "pin": {
      showpin = true;
      break;
    }
    case "radius": {
      showradius = true;
      break;
    }
    case "both": {
      showpin = true;
      showradius = true;
      break;
    }
  }

  var loc = { lat: lat, lng: lng };
  map = new google.maps.Map($advLocationMap[0], {
    center: { lat, lng },
    disableDefaultUI: true,
    zoom,
  });

  if (showradius) {
    cityCircle = new google.maps.Circle({
      center: loc,
      fillColor: "#0f7b3f",
      fillOpacity: 0.35,
      map: map,
      radius: radius * 1609.34,
      strokeColor: "#0f7b3f",
      strokeOpacity: 0.8,
      strokeWeight: 2,
    });
  }

  if (showpin) {
    new google.maps.Marker({
      position: loc,
      map,
      icon: "/Content/images/v3/map-pin_primary-green.svg",
    });
  }
}

function init(): void {
  window["adviserLocationMapBootstrap"] = () => {
    initMap();
  };
}

export default { init };
